import template from "./quoter-master-loader.html";

const QuoterMasterLoaderComponent = {
  template: template,
};

export default QuoterMasterLoaderComponent;
